import React, { CSSProperties, forwardRef, ReactNode } from 'react';
import InfoTooltip from '@uikit/Info/InfoTooltip/InfoTooltip';

type BaseButtonProps = {
  dataTestId: string;
  disabled?: boolean;
  isLoading?: boolean;
  type?: 'button' | 'submit' | 'reset';
  title: string;
  onClick: () => void;
  variant?: 'base' | 'link' | 'outline';
  Icon?: ReactNode;
  iconPosition?: 'left' | 'right';
  className?: string;
  style?: CSSProperties;
  tooltipTitle?: string;
};

export const BaseButton = forwardRef<HTMLButtonElement, BaseButtonProps>(
  (
    {
      dataTestId,
      disabled,
      isLoading,
      type = 'button',
      title,
      onClick,
      variant = 'base',
      className,
      style,
      iconPosition = 'left',
      Icon,
      tooltipTitle,
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        disabled={disabled}
        data-test-id={`${dataTestId}-button`}
        className={`custom-button ${variant} ${className}`}
        style={style}
        onClick={onClick}
      >
        {isLoading ? (
          <span className="spinner" />
        ) : (
          <InfoTooltip
            className="custom-button tooltip-inside-button"
            title={tooltipTitle}
          >
            <>
              {iconPosition === 'left' && Icon}
              {title}
              {iconPosition === 'right' && Icon}
            </>
          </InfoTooltip>
        )}
      </button>
    );
  }
);
